import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/system';
import { t } from 'i18next';

interface TrucksAssignedCountProps {
  assignedCount: number;
  stacked?: boolean;
  sx?: SxProps;
  totalCount: number;
}

export default function TrucksAssignedCount({
  assignedCount,
  stacked = false,
  sx,
  totalCount,
}: TrucksAssignedCountProps) {
  const theme = useTheme();
  const counts = `${assignedCount}/${totalCount}`;

  if (stacked) {
    return (
      <Box sx={{ alignItems: 'flex-end', display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            color: theme.brandV2.colors.treadBlack,
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '16px',
          }}
        >
          {counts}
        </Typography>
        <Typography
          sx={{
            color: theme.brandV2.colors.treadGray2,
            fontSize: '10px',
            lineHeight: '16px',
            whiteSpace: 'nowrap',
          }}
        >
          {t('form_fields.trucks_assigned')}
        </Typography>
      </Box>
    );
  }

  return (
    <Typography variant="body2" sx={sx}>
      <Typography
        component="span"
        sx={{
          color: theme.brandV2.colors.treadBlack,
          fontSize: 'inherit',
          fontWeight: 600,
        }}
      >
        {counts}
      </Typography>
      <Typography
        component="span"
        sx={{ color: theme.brandV2.colors.treadGray2, fontSize: 'inherit' }}
      >{` ${t('form_fields.trucks_assigned')}`}</Typography>
    </Typography>
  );
}
